import { Component, TemplateRef, inject } from '@angular/core';
import { AppToastService } from 'app/core/services/app-toast.service';
import { NgTemplateOutlet } from '@angular/common';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    imports: [NgbToast, NgTemplateOutlet]
})
export class ToastComponent {
  toastService = inject(AppToastService);


  isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }

  hide(toast: any) {
    this.toastService.remove(toast);
  }
}
